import zsmLayout from '@/zsm-layout'

const shopRouter = {
  path: '/material',
  component: zsmLayout,
  name: 'material',
  children: [
    {
      redirect: '/material/video',
      path: '/material',
      component: () => import('@/view/material/index'),
      name: 'material',
      meta: {
        title: '素材库', icon: 'riFill-database-fill', affix: true,
        childList: [
          { meta: { title: '视频' }, title: '视频', path: '/material/video' },
          { meta: { title: '音频' }, title: '音频', path: '/material/audio' },
          { meta: { title: '图片' }, title: '图片', path: '/material/image' }
        ]
      },
      children: [
        // {
        //   path: '/material/video-copy',
        //   component: () => import('@/view/material-old/video'),
        //   name: 'material',
        //   hidden: true
        // },
        // {
        //   path: '/material/audio-copy',
        //   component: () => import('@/view/material-old/audio'),
        //   name: 'material',
        //   hidden: true
        // },
        {
          path: '/material/video',
          component: () => import('@/view/material/video'),
          name: 'material',
          hidden: true
        },
        {
          path: '/material/image',
          component: () => import('@/view/material/image'),
          name: 'material',
          hidden: true
        },
        {
          path: '/material/audio',
          component: () => import('@/view/material/audio'),
          name: 'material',
          hidden: true
        },
        {
          path: '/material/group',
          component: () => import('@/view/material/group/video'),
          redirect: '/material/group/video',
          name: 'material',
          hidden: true,
          children: [
            {
              path: '/material/group/video',
              component: () => import('@/view/material/group/video'),
              name: 'video',
              hidden: true
            },
            {
              path: '/material/group/image',
              component: () => import('@/view/material/group/image'),
              name: 'image',
              hidden: true
            },
            {
              path: '/material/group/audio',
              component: () => import('@/view/material/group/audio'),
              name: 'path',
              hidden: true
            }
          ]
        },

      ]
    }
  ]
}

export default shopRouter
